import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { userTypes } from '../../types/user';

import { CheckCircleIcon, H1, Link } from '../../components/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { selectNavigationOpen } from '../../navigation/reducer';
import { toggleNavigationMain } from '../../navigation/actions';
import { getUserData } from '../../user/selectors';

export const PasswordResetSent = ({ isModal, navigationOpen, toggleNavigationMain, userData }) => {
  if (navigationOpen && userData && userData.username) {
    toggleNavigationMain();
  }
  return (
    <div>
      <CheckCircleIcon className='large headline-3 mt10-sm p2-sm prl3-sm' />
      <H1 className='mt6-sm mb12-sm'>
        <TranslatedCopy id='password.recover.title' />
      </H1>
      {!isModal && navigationOpen && (
        <Link
          to='/login'
          className='mt12-sm pt2-sm pr5-sm pb2-sm pl5-sm ncss-btn-dark-grey u-full-width'
          data-desc='emailSent__link_login'
        >
          <TranslatedCopy id='login.return' />
        </Link>
      )}
    </div>
  );
};

PasswordResetSent.propTypes = {
  isModal: PropTypes.bool,
  navigationOpen: PropTypes.bool.isRequired,
  userData: userTypes,
  toggleNavigationMain: PropTypes.func.isRequired
};
PasswordResetSent.defaultProps = {
  isModal: false,
  userData: null
};

const mapStateToProps = state => ({
  navigationOpen: selectNavigationOpen(state),
  userData: getUserData(state)
});

const connector = connect(mapStateToProps, {
  toggleNavigationMain
});

export default connector(PasswordResetSent);
